import React from 'react';
import RecordSearchSelect from '../RecordSearchSelect';

const DEAL_PARAMS = { limit: 20 };

const dealRow = (d) => <>{d.title} {d.account_name && <span className="text-xs text-stone-400">{d.account_name}</span>}</>;

/** Search the org's deals by title or company and pick one: `onPick(deal)`. `excludeIds` are deal ids to hide,
 *  such as the deals a contact is already linked to (#906). */
export default function DealSearchSelect({ onPick, excludeIds, placeholder = 'Search deals…', testId = 'deal-search-select' }) {
    return (
        <RecordSearchSelect
            endpoint="/deals" params={DEAL_PARAMS} rowKey="deal_id" renderRow={dealRow}
            excludeIds={excludeIds} onPick={onPick} placeholder={placeholder}
            emptyText="No matching deals" testId={testId} />
    );
}
